import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { API, EVENT_TYPES } from '../API';
import { DIALOG_TYPE_ERROR, DIALOG_TYPE_INFO } from './ModalDialog';

const _api = Symbol();
const _passwordChangeHandler = Symbol();

export class RegistrationRequest extends BaseElement {
	constructor() {
		super();

		this.library.add(faCheck);

		this[_passwordChangeHandler] = message => {
			this.emit('show-dialog', {
				title: 'Password Change Request',
				message
			});
		};
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					
				}
				legend {
					padding: 0 0.5em;
					border-bottom: none;
					font-weight: bold;
				}
				form {
					display: flex;
					flex-direction: column;
				}
				form > div {
					flex: 1 0;
					margin-top: 0.5em;
				}
				label {
					display: flex;
				}
				label > span {
					min-width: 8em;
				}
				label > input {
					flex: 1 0;
				}
				input[type="text"],
				input[type="email"],
				input[type="tel"],
				button {
					background-color: #fff;
				}
				.buttons {
					text-align: end;
				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });

		this.api.on(EVENT_TYPES.EVENT_TYPE_PASSWORD_CHANGE, this[_passwordChangeHandler]);
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api.off(null, this[_passwordChangeHandler]);

		this.api = null;
	}
	async handleSubmit(e) {
		try {
			e.preventDefault();
			if(!this.api)
				throw new Error('api property not set!');
			
			const target = e.target;
			
			const { physicianName, npi, email, contactName, contactPhone } = Object.fromEntries(new FormData(target));
			
			if(!physicianName)
				throw new Error('Please enter a physician name.');
			if(!contactPhone)
				throw new Error('Please enter a contact number.');
			
			const response = await this.api.registrationRequest(physicianName, npi, email, contactName, contactPhone);
			this.emit('show-dialog', {
				title: 'Registration Request',
				message: response,
				type: DIALOG_TYPE_INFO
			});
			target.reset();
		}
		catch(err) {
			this.emit('show-dialog', {
				title: 'Registration Request Error',
				message: err.message,
				type: DIALOG_TYPE_ERROR
			});
		}
	}
	render() {
		return html`
			<fieldset>
				<legend>Registration Request</legend>
				<p class="info">
					<i class="icon fas fa-info-circle"></i>
					To get started, please fill out this registration form. A Kinex representative will contact you shortly.
				</p>
				<form @submit="${e => this.handleSubmit(e)}">
					<div>
						<label>
							<span>Physician Name</span>
							<input type="text" name="physicianName" placeholder="Dr. John Doe" />
						</label>
					</div>
					<div>
						<label>
							<span>Physician NPI</span>
							<input type="text" name="npi" placeholder="1234567890" />
						</label>
					</div>
					<div>
						<label>
							<span>Email Address</span>
							<input type="text" name="email" placeholder="johndoe@practice.com" />
						</label>
					</div>
					<div>
						<label>
							<span>Contact Name</span>
							<input type="text" name="contactName" placeholder="Office Manager" />
						</label>
					</div>
					<div>
						<label>
							<span>Contact Number</span>
							<input type="tel" name="contactPhone" placeholder="(123)456-7890" />
						</label>
					</div>
					<div class="buttons">
						<button type="submit">
							<i class="icon fas fa-check"></i>
							Submit
						</button>
					</div>
				</form>
			</fieldset>
		`;
	}
}

customElements.define('pp-registration-request', RegistrationRequest);